import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { SnackbarContext } from '../../state/SnackbarContextProvider';
import { notifyBugsnagHandledError } from '../../utils/bugsnagClient';

/**
 * Wraps an onboarding step's Next handler (PLA-425). When the save inside it
 * fails, the teacher sees the generic save error, Bugsnag gets a handled error,
 * and the handler stops there, so the step neither tracks nor advances.
 */
export default function useOnboardingSave() {
	const { t } = useTranslation();
	const { openSnackbar } = useContext(SnackbarContext);

	return useCallback(
		async (handler: () => Promise<void>) => {
			try {
				await handler();
			} catch (error) {
				notifyBugsnagHandledError(error as Error);
				openSnackbar({ type: 'error', message: t('An error occurred while saving changes') });
			}
		},
		[openSnackbar, t]
	);
}
